"use client";
import React from "react";
import Slider from "react-slick";
import styles from "./Images.module.css";
import dark from "./ImagesDark.module.css";
import TOKENMAP from "../../data/token_map.json";

const ImageSlider = ({ first, last, theme }) => {
  const settings = {
    dots: false,
    infinite: true,
    autoPlay: true,
    adaptiveHeight: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    centerMode: false, // Set this to false if you don't want centered images
    responsive: [
      {
        breakpoint: 768, // Adjust the breakpoint as needed
        settings: {
          slidesToShow: 2, // Show 2 slides on mobile screens
        },
      },
    ],
  };
  const data = Object.entries(TOKENMAP).map(([key, value]) => ({
    image: value.image,
    tokenId: value.tokenId,
  }));

  console.log({ data });
  return (
    <div className={theme ? styles.container : dark.container}>
      <Slider {...settings}>
        {data.slice(first, last).map((val) => (
          <img className={styles.image} key={val.tokenId} src={val.image} />
        ))}

        {/* Rest of the slides */}
      </Slider>
    </div>
  );
};

export default ImageSlider;
